import { QueryClient, QueryClientProvider } from 'react-query';
import { Route, Routes } from "react-router-dom";
import { SnackbarProvider } from 'notistack';
import { useEffect, Suspense } from 'react';

import { CssBaseline } from '@mui/material/';
import { makeStyles } from "@mui/styles";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import "i8n/i18n";

import 'swiper/css';
import 'swiper/css/scrollbar';
import "swiper/css/pagination";

import 'react-phone-number-input/style.css'

import { createMuiTheme } from 'components/app/theme';
import { loadComponent } from './loadComponent';
import { registerEventListener } from 'utils/useBeforeinstallprompt';
import { useGetTheme } from 'theming/useGetTheme';
import BonusSnackbar from 'components/selector/common/Snackbars/bonus/Snackbar';
import Widgets from './Widgets';
import withMemo from 'utils/withMemo';

const useStyles = makeStyles({
  containerRoot: {
    whiteSpace: 'pre-line',
  }
});

const queryClient = new QueryClient();

const ThemedApp = ({ appVersion, themePath, allowWebAuthN }) => {

  const Component = loadComponent(`app/AppV${appVersion ? appVersion : 1}`);

  return (
    <Suspense fallback={null}>
      <Component themePath={themePath} allowWebAuthN={allowWebAuthN} />
    </Suspense>
  )
}

const LazyApp = withMemo(ThemedApp, ['appVersion', 'themePath']);
const LazyWidgets = withMemo(Widgets, ['appVersion', 'themePath']);

registerEventListener();

function App() {
  const classes = useStyles();
  const theme = useGetTheme();

  useEffect(() => {
    if (theme.docTitle) {
      document.title = theme.docTitle;
    }
  }, [theme.docTitle]);

  return (
    <MuiThemeProvider theme={createMuiTheme(theme.id)} >
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        classes={{ containerRoot: classes.containerRoot }}
        Components={{
          bonusReceived: BonusSnackbar,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route path={'/widgets/*'} element={
              <LazyWidgets themePath={theme.path || theme.id} />}
            />
            <Route path="*" element={
              <LazyApp appVersion={theme.appVersion} themePath={theme.path || theme.id} allowWebAuthN={theme.allowWebAuthN} />
            } />
          </Routes>
        </QueryClientProvider>
      </SnackbarProvider>
    </MuiThemeProvider>
  );
}

export default App;
